import { useState } from "react";
import "../styles/sliderCalculator.css";
import { Button } from "react-bootstrap";

export default function SliderCalculator() {
  const [clients, setClients] = useState(20);

  const GOV_SUPPORT_FOR_ONE_WORKER = 1_850_000;
  const revenue = clients * GOV_SUPPORT_FOR_ONE_WORKER;

  return (
    <>
      <h2 className="h2 mt-5">Mekkora támogatásra lenne jogosult a céged?</h2>
      <section className="slider-calculator section p-0">
        <div className="calculator-wrapper py-2 px-1">
          <h3 className="h4">
            <span className="number">{clients}</span> munkavállaló képzése
            esetén:
          </h3>

          <input
            type="range"
            min={10}
            max={250}
            step={5}
            value={clients}
            onChange={(e) => setClients(Number(e.target.value))}
            className="slider"
          />

          <div className="revenue-block">
            <div className="revenue-text">
              Várható támogatás mértéke a képzési időszak alatt*:
            </div>
            <div className="revenue-value">
              <strong>{revenue.toLocaleString()} Ft</strong>
            </div>
            <div className="disclaimer mt-3">
              *A feltüntetett összeg az eddigi tapasztalatok alapján kalkulált
              átlagos támogatás. A tényleges összeg a képzési területtől és a
              képzési időtartamtól függ.
            </div>
          </div>
        </div>
        <div className="text-center mt-5">
          <Button href="#leadform" className="btn btn-primary">
            Szeretném igényelni a támogatást!
          </Button>
        </div>
      </section>
    </>
  );
}
